<div *ngIf="loading" class="overlay" aria-live="assertive" aria-busy="true">
    <div class="overlay-content">
        <div class="spinner-border text-primary" style="font-size: 25px;" role="status" aria-hidden="true"></div>
        <div class="message-container">
            <div class="message">{{ message }}</div>
        </div>
        <div class="progress" *ngIf="loadingDocuments">
            <div class="progress-bar" role="progressbar" [style.width.%]="progressPercentage" [attr.aria-valuenow]="progressPercentage" aria-valuemin="0" aria-valuemax="100">
                {{ progressPercentage.toFixed(0) }}%
            </div>
        </div>
    </div>
</div>